module.exports = __webpack_public_path__ + "img/214.47d432d4.jpg";